import 'react-quill/dist/quill.snow.css'
import PolicyEditor from '../../../Utilities/PolicyEditor'

const DoNotSell = () => {
  return <PolicyEditor title="Do Not Sell" fieldKey="doNotSell" />
}

export default DoNotSell
